import { createAsyncAction } from 'typesafe-actions';
import { ApiRequestStartActionTypes, ApiRequestEndActionTypes, GetDashboardActionTypes } from './types';

export const apiRequestStart = createAsyncAction(
    ApiRequestStartActionTypes.REQUEST,
    ApiRequestStartActionTypes.SUCCESS,
    ApiRequestStartActionTypes.ERROR
)<undefined, undefined, undefined>();

export const apiRequestEnd = createAsyncAction(
    ApiRequestEndActionTypes.REQUEST,
    ApiRequestEndActionTypes.SUCCESS,
    ApiRequestEndActionTypes.ERROR
)<undefined, undefined, undefined>();

export const getDashboard = createAsyncAction(
    GetDashboardActionTypes.REQUEST,
    GetDashboardActionTypes.SUCCESS,
    GetDashboardActionTypes.ERROR
)<undefined, undefined, undefined>();
